import {useEffect, useRef} from 'react';

export default function SecureImage({imageSrc}) {
  
  const canvasRef = useRef(null);
  
  useEffect(() => {  
    const canvas = canvasRef.current;
    if(!canvas || !imageSrc) return;
    
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      if (canvas) {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      }}

    img.crossOrigin = "anonymous"; 
    img.src = imageSrc;

  }, [imageSrc])

  const preventDefaultActions = (e) => {
    e.preventDefault();
  };

  return (
    <div 
      style={{display: 'inline-block', position: 'relative'}}
      onContextMenu={preventDefaultActions}
      onDragStart={preventDefaultActions}>
      <canvas ref={canvasRef} style={{maxWidth: '100%', height: 'auto'}} />
      {/* Invisible overlay div to block element selection/touch targets */}
      <div 
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'transparent',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          WebkitTouchCallout: 'none' // Disables the native iOS long-press magnifying bubble
        }} 
      />
    </div>
  );
};
